// src/components/AnalyticsTracker.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Deklarujemy globalną funkcję gtag, aby TypeScript wiedział, że ona istnieje
declare global {
    interface Window {
        gtag: (command: string, trackingId: string, config: { page_path: string }) => void;
    }
}

const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        // Sprawdzamy, czy funkcja gtag istnieje w oknie przeglądarki
        if (typeof window.gtag === 'function') {
            // Wysyłamy informację o nowej odsłonie do Google Analytics
            window.gtag('config', 'G-EFD3GCEQZ9', {
                page_path: location.pathname + location.search,
            });
        }
    }, [location]); // Ten efekt uruchomi się za każdym razem, gdy zmieni się lokalizacja

    return null; // Ten komponent niczego nie renderuje, działa w tle
};

export default AnalyticsTracker;
